import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { VatHandlingTypesDataGrid } from "src/components/views/erp/sales/masterData/vatHandlingTypes/VatHandlingTypesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/vatHandlingTypes")({
	staticData: { title: i18n.t("vat_handling_types"), legacyViewKey: "vatHandlingTypesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <VatHandlingTypesDataGrid />;
}
